/* @flow */
import * as React from 'react';

import { Box } from '@sonyged/proc-ui';
import css from '@styled-system/css';
import styled from 'styled-components';

import type { Belt } from '../../rules/types';
import { SushiIcon } from './SushiIcon';

type Props = {
  scale: number,
  belt: Belt,
  t: number,
  eatingCustomerIndice: Array<number>,
};

export function SushiIconList(props: Props) {
  const { belt, eatingCustomerIndice, t, scale } = props;

  const visibles = [t, t + 1, t + 2].map(x => (x + belt.length) % belt.length);
  const eatings = eatingCustomerIndice.map(x => (x + t + belt.length) % belt.length);

  return (
    <Container>
      {belt
        .map((s, i) => {
          if (!s.sushi) return;
          let status = 'hidden';
          if (visibles.some(x => x === i)) status = 'visible';
          if (s.type === 'eaten') status = 'finish';
          if (eatings.some(x => x === i)) status = 'eating';
          return s.type !== 'empty' && <SushiIcon key={i} scale={scale} status={status} sushi={s.sushi} />;
        })
        .reverse()}
    </Container>
  );
}

const Container = styled(Box)(
  css({
    position: 'absolute',
    bottom: '80px',
    width: '100%',
    display: 'flex',
    '> *:last-child': {
      mr: 'auto !important',
    },
    '> *:first-child': {
      ml: 'auto !important',
    },
  })
);
